const escapeCsvValue = (value) => {
  if (value === null || value === undefined) return '';
  const str = String(value);
  const trimmed = str.trim();

  // If the string looks numeric but Excel would mangle it (e.g. "001" → 1, "1.5.0" stays safe),
  // wrap it as ="..." so Excel and Google Sheets treat it as text.
  if (trimmed !== '' && !isNaN(trimmed) && String(Number(trimmed)) !== trimmed) {
    return `="${str.replace(/"/g, '""')}"`;
  }

  if (str.includes(',') || str.includes('"') || str.includes('\n') || str.includes('\r')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

export const downloadCsv = (filename, headers, rows) => {
  const headerRow = headers.map(escapeCsvValue).join(',');
  const dataRows = rows.map((row) => row.map(escapeCsvValue).join(','));
  const csvContent = [headerRow, ...dataRows].join('\r\n');

  // UTF-8 BOM so Excel opens it correctly
  const blob = new Blob(['﻿' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
